import { render } from "./Add.vue?vue&type=template&id=470d0bc6&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=470d0bc6&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470d0bc6"],['__file',"resources/js/pages/rdv/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "470d0bc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('470d0bc6', __exports__)) {
    console.log('reload')
    api.reload('470d0bc6', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=470d0bc6&scoped=true", () => {
    console.log('re-render')
    api.rerender('470d0bc6', render)
  })

}


export default __exports__